import {
  CalendarRange,
  Database,
  FileText,
  GitBranch,
  MessagesSquare,
  Mic,
  Rss,
  Video,
  type LucideIcon,
} from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import type { ProjectResourceType } from '../types';

/** Design §12 table: label + icon per type value. Badge variant `secondary`. */
const RESOURCE_TYPES: Record<ProjectResourceType, { label: string; icon: LucideIcon }> = {
  meeting: { label: 'Meeting', icon: Video },
  planning: { label: 'Planning', icon: CalendarRange },
  'storage-collection': { label: 'Storage collection', icon: Database },
  repository: { label: 'Repository', icon: GitBranch },
  conversation: { label: 'Conversation', icon: MessagesSquare },
  'indexer-source': { label: 'Indexer source', icon: Rss },
  voice: { label: 'Voice', icon: Mic },
  file: { label: 'File', icon: FileText },
};

export const RESOURCE_TYPE_ORDER = Object.keys(RESOURCE_TYPES) as ProjectResourceType[];

export function resourceTypeLabel(type: ProjectResourceType | string): string {
  return RESOURCE_TYPES[type as ProjectResourceType]?.label ?? String(type);
}

export interface ResourceTypeBadgeProps {
  type: ProjectResourceType | string;
  /** Screen-reader text for the icon (defaults to the label). */
  srLabel?: string;
}

/** Type badge: decorative icon + label (C5), secondary variant (B1). */
export function ResourceTypeBadge({ type }: ResourceTypeBadgeProps) {
  const config = RESOURCE_TYPES[type as ProjectResourceType];
  const Icon = config?.icon;
  const label = config?.label ?? String(type);

  return (
    <Badge variant="secondary" className="gap-1.5">
      {Icon ? <Icon className="h-3.5 w-3.5" aria-hidden="true" /> : null}
      {label}
    </Badge>
  );
}
